module.exports = __webpack_public_path__ + "media/stem/sc-left-c19b5648.svg";